<script lang="ts" setup>
  import SvgIcon from '@shared/components/svg-icon.vue'

  withDefaults(
    defineProps<{
      title: string
      isCloseButton?: boolean
    }>(),
    {
      isCloseButton: false,
    }
  )

  const emit = defineEmits(['on-close'])
  const close = () => {
    emit('on-close')
  }
</script>

<template>
  <div
    class="tw-bg-white tw-transition-[width] tw-shadow-100 tw-w-full tw-h-full tw-absolute md:tw-static md:tw-min-w-[450px] md:tw-max-w-[450px] tw-z-20 tw-flex tw-flex-col"
  >
    <div
      class="tw-h-[75px] tw-flex-shrink-0 tw-px-12 tw-flex tw-items-center tw-justify-between tw-border-b tw-border-grey-400"
    >
      <h4 class="tw-text-headline-4">{{ title }}</h4>
      <button v-if="isCloseButton" @click="close">
        <svg-icon class="tw-fill-primary-100" name="remove" size="20" />
      </button>
    </div>
    <slot name="body" />
    <div
      class="md:tw-mx-16 tw-pb-50 md:tw-pb-32 tw-pt-8 md:tw-pt-24 tw-mt-auto tw-border-t tw-border-grey-400 tw-flex tw-flex-col tw-gap-8 md:tw-flex-row tw-items-center tw-shadow-600 md:tw-shadow-none md:tw-justify-between"
    >
      <slot name="controls" />
    </div>
  </div>
</template>
